import { type FC } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import compress from '../assets/bulletsIcon/compress.svg';
import convert from '../assets/bulletsIcon/convert.svg';
import edit from '../assets/bulletsIcon/edit.svg';
import merge from '../assets/bulletsIcon/merge.svg';
import ocr from '../assets/bulletsIcon/ocr.svg';

const bullets = [
  {
    icon: edit,
    text: <Trans i18nKey='upsale_modal.edit_and_convert_files' />,
    key: 'edit_and_convert_files'
  },
  {
    icon: convert,
    text: <Trans i18nKey='upsale_modal.translate_and_summarize' />,
    key: 'translate_and_summarize'
  },
  {
    icon: merge,
    text: <Trans i18nKey='upsale_modal.merge_or_split_pdfs' />,
    key: 'merge_or_split_pdfs'
  },
  {
    icon: compress,
    text: <Trans i18nKey='upsale_modal.compress_pdfs' />,
    key: 'compress_pdfs'
  },
  {
    icon: ocr,
    text: <Trans i18nKey='upsale_modal.ocr_scanned_files' />,
    key: 'ocr_scanned_files'
  },
  {
    icon: edit,
    text: <Trans i18nKey='upsale_modal.remove_watermark' />,
    key: 'remove_watermark'
  }
];

const DetailsBlock: FC = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-4 px-4 tablet:px-6'>
      <h3 className='text-[16px] font-[700] leading-[22px] mt-4 pt-4 border-t border-[#5f30e214]'>
        {t('upsale_modal.1_credit_gives_you')}
      </h3>
      <div className='flex tablet:flex-row gap-4 pb-4 border-b border-[#5f30e214]'>
        <ul className='flex flex-col gap-4 flex-1'>
          {bullets.slice(0, 3).map((bullet) => (
            <li
              key={bullet.key}
              className='flex items-center gap-2'
            >
              <img
                src={bullet.icon}
                alt={bullet.key}
              />
              <p>{bullet.text}</p>
            </li>
          ))}
        </ul>
        <ul className='flex flex-col gap-4 flex-1'>
          {bullets.slice(3, 6).map((bullet) => (
            <li
              key={bullet.key}
              className='flex items-center gap-2'
            >
              <img
                src={bullet.icon}
                alt={bullet.key}
              />
              <p>{bullet.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DetailsBlock;
